import { useAppInfo } from 'AppState';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import { BASE_URL } from '../../../apiConfig';

export default function useUpdateOnboarding() {
    const {dispatchApp,stateApp} = useAppInfo()
    

    async function UpdateOnboarding(username,data) {

        try {
          const response = await axios.post(`${BASE_URL}/addOnboarding/`, {
            username: username,
            userId: stateApp.userId,
            onboarding: data
          });
          dispatchApp({
            onboarding: data,
            username: username,
            displayName: username
          });
          return response.data; // Return the response data if needed
        } catch (error) {
          console.error("Error updating onboarding status: ", error);
          return error; // Return the error object for further handling if needed
        }
      }
    
    return UpdateOnboarding
    
}

export function useHandleRoleChange() {
    const { dispatchApp,stateApp } = useAppInfo();
    const { onboarding } = stateApp;
    const navigate = useNavigate();
    const UpdateOnboarding = useUpdateOnboarding();
    const handleRoleChange = async (newRole) => {
      try {
        // Update onboarding state
        const updatedOnboarding = { ...onboarding, userRole: newRole};
        await UpdateOnboarding(stateApp.username, updatedOnboarding);
        dispatchApp({onboarding: updatedOnboarding});
        navigate("/")
      } catch (error) {
        console.error("Error updating role:", error);
      }
    };

    return handleRoleChange
}
